module.exports = __webpack_public_path__ + "assets/images/android_first_install-6a8902070928952d66c07eeb0307d9fb.mp4";